function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import screenfull from 'screenfull';
import { Session, Local } from '@/utils/storage.js';
import UserNews from '@/layout/navBars/breadcrumb/userNews.vue';
import Search from '@/layout/navBars/breadcrumb/search.vue';
import Cookies from 'js-cookie';
// todo 消息
// import { needDealtList } from '@/api/system'
import { editFormApi } from '@/api/user';
export default {
  name: 'layoutBreadcrumbUser',
  components: {
    UserNews: UserNews,
    Search: Search
  },
  data: function data() {
    return {
      isScreenfull: false,
      isShowUserNewsPopover: true,
      disabledI18n: 'zh-cn',
      disabledSize: '',
      isDot: false,
      label: {
        mer_name: 'admin'
      },
      list: [],
      dealtList: []
    };
  },
  computed: {
    // 获取用户信息
    getUserInfos: function getUserInfos() {
      return this.$store.state.user;
    },
    // 设置弹性盒子布局 flex
    layoutUserFlexNum: function layoutUserFlexNum() {
      var _this$$store$state$th = this.$store.state.themeConfig.themeConfig,
        layout = _this$$store$state$th.layout,
        isClassicSplitMenu = _this$$store$state$th.isClassicSplitMenu;
      var num = '';
      if (layout === 'defaults' || layout === 'classic' && !isClassicSplitMenu || layout === 'columns') num = 1;else num = null;
      return num;
    }
  },
  mounted: function mounted() {
    if (Local.get('JavaMerThemeConfigPrev')) {
      this.initI18n();
      this.initComponentSize();
    }
  },
  methods: {
    initIsDot: function initIsDot(status) {
      this.isDot = status;
    },
    openNews: function openNews() {
      // this.isShowUserNewsPopover = !this.isShowUserNewsPopover;
      this.isDot = false;
    },
    // 搜索点击
    onSearchClick: function onSearchClick() {
      this.$refs.searchRef.openSearch();
    },
    // 布局配置点击
    onLayoutSetingClick: function onLayoutSetingClick() {
      this.bus.$emit('openSetingsDrawer');
    },
    refresh: function refresh() {
      this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    },
    // 待办列表
    getTodoList: function getTodoList() {
      var _this = this;
      needDealtList().then(function (res) {
        _this.list = res.data;
        _this.dealtList = res.data.length > 3 ? res.data.slice(0, 3) : res.data;
      }).catch(function (res) {});
    },
    // 全屏点击
    onScreenfullClick: function onScreenfullClick() {
      var _this2 = this;
      if (!screenfull.isEnabled) {
        this.$message.warning('暂不不支持全屏');
        return false;
      }
      screenfull.toggle();
      screenfull.on('change', function () {
        if (screenfull.isFullscreen) _this2.isScreenfull = true;else _this2.isScreenfull = false;
      });
      // 监听菜单 horizontal.vue 滚动条高度更新
      this.bus.$emit('updateElScrollBar');
    },
    // 组件大小改变
    onComponentSizeChange: function onComponentSizeChange(size) {
      Local.remove('JavaMerThemeConfigPrev');
      this.$store.state.themeConfig.themeConfig.globalComponentSize = size;
      Local.set('JavaMerThemeConfigPrev', this.$store.state.themeConfig.themeConfig);
      this.$ELEMENT.size = size;
      this.initComponentSize();
      window.location.reload();
    },
    // 语言切换
    onLanguageChange: function onLanguageChange(lang) {
      Local.remove('JavaMerThemeConfigPrev');
      this.$store.state.themeConfig.themeConfig.globalI18n = lang;
      Local.set('JavaMerThemeConfigPrev', this.$store.state.themeConfig.themeConfig);
      this.$i18n.locale = lang;
      this.initI18n();
    },
    // 初始化言语国际化
    initI18n: function initI18n() {
      switch (Local.get('JavaMerThemeConfigPrev').globalI18n) {
        case 'zh-cn':
          this.disabledI18n = 'zh-cn';
          break;
        case 'en':
          this.disabledI18n = 'en';
          break;
        case 'zh-tw':
          this.disabledI18n = 'zh-tw';
          break;
      }
    },
    // 初始化全局组件大小
    initComponentSize: function initComponentSize() {
      switch (Local.get('JavaMerThemeConfigPrev').globalComponentSize) {
        case '':
          this.disabledSize = '';
          break;
        case 'medium':
          this.disabledSize = 'medium';
          break;
        case 'small':
          this.disabledSize = 'small';
          break;
        case 'mini':
          this.disabledSize = 'mini';
          break;
      }
    },
    // `dropdown 下拉菜单` 当前项点击
    onDropdownCommand: function onDropdownCommand(path) {
      var _this3 = this;
      if (path === 'logOut') {
        setTimeout(function () {
          _this3.$msgbox({
            closeOnClickModal: false,
            closeOnPressEscape: false,
            title: '提示',
            message: '此操作将退出登录, 是否继续?',
            showCancelButton: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'deleteConfirm',
            beforeClose: function () {
              var _beforeClose = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(action, instance, done) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '退出中';
                        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                          return _regenerator().w(function (_context) {
                            while (1) switch (_context.n) {
                              case 0:
                                _context.n = 1;
                                return _this3.$store.dispatch('user/handleLogout');
                              case 1:
                                _this3.$router.push("/login?redirect=".concat(_this3.$route.fullPath));
                                done();
                              case 2:
                                return _context.a(2);
                            }
                          }, _callee);
                        })), 150);
                      } else {
                        done();
                      }
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              function beforeClose(_x, _x2, _x3) {
                return _beforeClose.apply(this, arguments);
              }
              return beforeClose;
            }()
          }).then(function () {
            // 清除缓存/token等
            Session.clear();
            // 使用 reload 时，不需要调用 resetRoute() 重置路由
            window.location.reload();
          }).catch(function () {});
        }, 150);
      } else {
        this.$router.push("/maintain/user/".concat(path));
      }
    }
  }
};